module.exports = __webpack_public_path__ + "static/media/subjectCreditRecordDealerTemp.c682b43e.xlsx";